/* Product review affordance — safe with Shopify's native contact form. */
(function () {
  function openReview(details) {
    if (!details) return;
    details.open = true;
    if (typeof details.scrollIntoView === 'function') {
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-pp-review-open]');
    if (!opener) return;
    var details = document.getElementById('pp-review-write');
    if (!details) return;
    event.preventDefault();
    openReview(details);
    if (history && history.replaceState) history.replaceState(null, '', '#pp-review-write');
  });
  function initReviewForms() {
    var details = document.getElementById('pp-review-write');
    if (!details) return;
    if (window.location.hash === '#pp-review-write' || details.querySelector('[data-pp-review-success], .pp-review-form-error')) {
      openReview(details);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviewForms);
  else initReviewForms();
  document.addEventListener('shopify:section:load', initReviewForms);
})();
